import React from "react";
import { FiArrowRight, FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { getProviderById } from "../../../services/GroupService";
import { useState } from "react";
import { useEffect } from "react";

function CareTeamLayout({ selectedGroup, providerId }) {
  const navigate = useNavigate()
  // console.log(selectedGroup)
  const user = localStorage.getItem('authUser')
  // const provider  = JSON.parse(user)
  console.log(selectedGroup.createdBy)
  const [provider, setProvider] = useState()
  // const {createdBy} = selectedGroup;
 

  useEffect(()=>{
    getProviderName()
  },[providerId])


  const getProviderName = async() => {
    try {
      const response = await getProviderById(providerId);
      if(response.status === 200){
        setProvider(response.data.data[0])
        console.log(provider)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return provider ? (
        <div
        className="d-flex flex-column justify-content-center my-2 align-items-start cursor-pointer"
        style={{
          height: "auto",
          width: "100%",
          //   backgroundColor: "rgba(227, 236, 237, 1)",
        }}
      >
        <div
          className="d-flex justify-content-between align-items-start p-1"
          style={{
            height: "auto",
            width: "100%",
            //   backgroundColor: "rgba(227, 236, 237, 1)",
          }}
        >
          <div className="d-flex align-content-center w-75">
            <img src={provider.profilePicture? provider.profilePicture : 'images/avatar.png'} alt="" className=" object-fit-cover me-2" style={{height:'50px',width:'50px', borderRadius:'50%'}} />
            <div className="flex flex-column justify-content-center ">
              <h3 style={{ fontSize: "16px" }}>{provider.full_name}</h3>
              <p style={{ fontSize: "12px" }}>
                  {provider._id}
              </p>
            </div>
          </div>
          <div onClick={()=>navigate('/myprofile',{state:provider})}>
            <span style={{ fontSize: "12px"}}> <span className="text-decoration-none" style={{ color:'rgba(175, 177, 178, 1)' }}>View profile <span style={{color:'rgba(21, 101, 99, 1)'}}><FiArrowRight size={'12px'}/></span></span> </span>
          </div>
        </div>
      </div>
   
  ) : (
    <div
      className="d-flex flex-column  justify-content-center align-items-center rounded px-2 py-5"
      style={{
        height: "500px",
        width: "100%",
        backgroundColor: "rgba(227, 236, 237, 1)",
      }}
    >
      <div className="d-flex flex-column text-center justify-content-center align-items-center px-2 py-3 ">
        <svg
          width="115"
          height="115"
          viewBox="0 0 115 115"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mb-3"
        >
          <path
            d="M64.6875 82.6562H57.5V75.4688C57.4971 72.6103 56.3604 69.8697 54.3391 67.8484C52.3178 65.8271 49.5772 64.6904 46.7188 64.6875H32.3438C29.4853 64.6904 26.7447 65.8271 24.7234 67.8484C22.7021 69.8697 21.5654 72.6103 21.5625 75.4688V82.6562H14.375V75.4688C14.3807 70.7049 16.2757 66.1378 19.6442 62.7692C23.0128 59.4007 27.5799 57.5057 32.3438 57.5H46.7188C51.4826 57.5057 56.0497 59.4007 59.4183 62.7692C62.7868 66.1378 64.6818 70.7049 64.6875 75.4688V82.6562ZM39.5312 21.5625C41.6636 21.5625 43.748 22.1948 45.521 23.3795C47.294 24.5641 48.6758 26.2479 49.4918 28.2179C50.3078 30.188 50.5213 32.3557 50.1053 34.4471C49.6893 36.5384 48.6625 38.4595 47.1547 39.9672C45.647 41.475 43.7259 42.5018 41.6346 42.9178C39.5432 43.3338 37.3755 43.1203 35.4054 42.3043C33.4354 41.4883 31.7516 40.1065 30.567 38.3335C29.3823 36.5605 28.75 34.4761 28.75 32.3438C28.75 29.4844 29.8859 26.7421 31.9078 24.7203C33.9296 22.6984 36.6719 21.5625 39.5312 21.5625ZM39.5312 14.375C35.9774 14.375 32.5033 15.4288 29.5483 17.4033C26.5934 19.3777 24.2903 22.184 22.9303 25.4674C21.5703 28.7508 21.2144 32.3637 21.9078 35.8493C22.6011 39.3349 24.3125 42.5366 26.8254 45.0496C29.3384 47.5625 32.5401 49.2739 36.0257 49.9672C39.5113 50.6606 43.1242 50.3047 46.4076 48.9447C49.691 47.5847 52.4973 45.2816 54.4717 42.3267C56.4462 39.3717 57.5 35.8976 57.5 32.3438C57.5 27.5781 55.6069 23.0077 52.2371 19.6379C48.8673 16.2681 44.2969 14.375 39.5312 14.375ZM7.1875 93.4375H107.812V100.625H7.1875V93.4375ZM98.1202 28.75C96.8417 28.7501 95.5762 29.0065 94.3984 29.504C93.2207 30.0015 92.1547 30.7301 91.2633 31.6466L89.8438 33.0984L88.4242 31.643C87.5327 30.7267 86.4667 29.9983 85.2889 29.501C84.1112 29.0037 82.8458 28.7474 81.5673 28.7474C80.2889 28.7474 79.0235 29.0037 77.8457 29.501C76.668 29.9983 75.6019 30.7267 74.7105 31.643C72.8925 33.52 71.876 36.0305 71.876 38.6436C71.876 41.2566 72.8925 43.7672 74.7105 45.6442L89.8438 61.0938L104.973 45.6478C106.791 43.7708 107.808 41.2602 107.808 38.6472C107.808 36.0341 106.791 33.5236 104.973 31.6466C104.083 30.7309 103.018 30.0029 101.842 29.5054C100.665 29.008 99.401 28.7511 98.1238 28.75H98.1202Z"
            fill="#1F7E78"
          />
        </svg>

        <p className="resFont">
          No Care Team Assigned to this group yet. Add Care Team by clicking{" "}
          <a href="" style={{color:'rgba(21, 101, 99, 1)'}}>here</a> or on the add button below
        </p>
        <span
          className=" text-white bold px-1 py-1 d-flex justify-content-center align-items-center "
          style={{ borderRadius: "50%",
        backgroundColor:'rgba(31, 126, 120, 1)' }}
        >
          <FiPlus fontSize={"1.3rem"} fontWeight={"bold"} />
        </span>
      </div>
    </div>
  );
}

export default CareTeamLayout;
